import React, { useEffect, useState } from 'react';
import { fetchNews, NewsItem } from '@/API/admin/news';
import { EditNewsModal } from './EditModal';

export const TableNews: React.FC = () => {
  const [newsList, setNewsList] = useState<NewsItem[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedNews, setSelectedNews] = useState<NewsItem | undefined>(
    undefined
  );

  useEffect(() => {
    const getData = async () => {
      const data = await fetchNews();
      setNewsList(data);
    };

    getData();
  }, []);

  const handleEdit = (newsItem: NewsItem) => {
    setSelectedNews(newsItem); // 編集対象のニュースを設定
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedNews(undefined); // モーダルを閉じたら selectedNews をクリア
  };
  const handleDelete = () => {
    console.log('delete');
  };

  return (
    <div className="overflow-x-auto">
      <div className="flex justify-center"></div>

      <table className="min-w-full bg-white rounded">
        <thead className="min-w-full bg-white border-b-2 border-[#DDDDDD] rounded">
          <tr>
            <th className="p-3 text-left text-black text-sm">リリース日</th>
            <th className="p-3 text-left text-black text-sm">タグ</th>
            <th className="p-3 text-left text-black text-sm">タイトル</th>
            <th className="p-3 text-left text-black text-sm">表示種類</th>
            <th className="p-3 text-left text-black text-sm"></th>
          </tr>
        </thead>
        <tbody>
          {newsList.map((item) => (
            <tr key={item.id} className="border-b border-[#DDDDDD]">
              <td className="px-[16px] py-4 text-black text-sm">
                {item.releaseDate}
              </td>
              <td className="px-[16px] py-4 text-black text-sm">{item.tag}</td>
              <td className="px-[16px] py-4 text-black text-sm">
                {item.title}
              </td>
              <td className="px-[16px] py-4 text-black text-sm">
                {item.displayType}
              </td>
              <td className="px-[16px] py-4 text-black text-xs">
                <div className="flex flex-row gap-2">
                  <span
                    className="bg-white px-2 py-1 border rounded text-xs cursor-pointer text-center"
                    onClick={() => handleEdit(item)} // 編集ボタン
                  >
                    編集
                  </span>
                  <span
                    className="bg-white px-2 py-1 border rounded text-xs cursor-pointer text-center"
                    onClick={() => handleDelete()}
                  >
                    削除
                  </span>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {isModalOpen && (
        <EditNewsModal
          isOpen={isModalOpen}
          onClose={closeModal}
          newsItem={selectedNews} // selectedNews がある場合は編集、ない場合は新規作成
        />
      )}
    </div>
  );
};
